import { WarningIcon } from "@/assets/icons";
import { cn } from "@/lib/utils";

interface LimitWarningProps {
  title?: string;
  message: string;
  className?: string;
}

const LimitWarning = ({ title, message, className }: LimitWarningProps) => {
  return (
    <div
      className={cn("flex items-start gap-2", className)}
      role="alert"
      aria-label="limit warning"
    >
      <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-red-50">
        <WarningIcon
          className="fill-cinnabar size-4"
          data-testid="warning-icon"
        />
      </div>

      <div className="flex flex-col">
        <div className="text-cinnabar leading-6 font-semibold text-xs">
          {title}
        </div>
        <span className="text-[0.625rem] text-neutral-500">{message}</span>
      </div>
    </div>
  );
};

export default LimitWarning;
